import {
  PROPOSE_TASK_DETAIL, PROPOSE_TASK_DETAIL_FAILURE, PROPOSE_TASK_DETAIL_SUCCESS
} from './mutation-types'

export default {
  state: {
    proposeTaskDetail: null
  },
  getters: {
    proposeTaskDetail: state => {
      return state.proposeTaskDetail
    }
  },
  actions: {
    [PROPOSE_TASK_DETAIL] ({dispatch, state, commit}, params) {
      const url = `/master/propose_tasks/${params.id}`
      let data = {}
      data = params.data
      let callback = null
      params.callback && (callback = params.callback)
      dispatch('apiGet', {url: url, data: data, callback: callback})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_TASK_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_TASK_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_TASK_DETAIL_FAILURE] (state, data) {
      console.log('PROPOSE_TASK_DETAIL_FAILURE')
    },
    [PROPOSE_TASK_DETAIL_SUCCESS] (state, data) {
      console.log('PROPOSE_TASK_DETAIL_SUCCESS')
      state.proposeTaskDetail = data.data[0]
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-task-detail.js